import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e04b0e24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lCommon" }
const _hoisted_2 = {
  key: 1,
  class: "pFAQ"
}
const _hoisted_3 = {
  key: 0,
  class: "pFAQ_categories_wrapper"
}
const _hoisted_4 = { class: "pFAQ_title" }
const _hoisted_5 = ["data-categoryId", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "pFAQ_description"
}
const _hoisted_7 = { class: "pFAQ_content_wrapper" }
const _hoisted_8 = { class: "pFAQ_title" }
const _hoisted_9 = ["data-streamId", "onClick"]
const _hoisted_10 = { class: "pFAQ_title" }
const _hoisted_11 = { class: "pFAQ_content" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "pFAQ_content_actions" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "pFAQ"
}
const _hoisted_16 = { class: "pFAQ_categories_wrapper" }
const _hoisted_17 = { class: "pFAQ_title" }
const _hoisted_18 = { class: "pFAQ_categories" }
const _hoisted_19 = ["data-streamId", "onClick"]
const _hoisted_20 = { class: "pFAQ_title" }
const _hoisted_21 = ["data-categoryId", "onClick"]
const _hoisted_22 = { class: "pFAQ_description" }
const _hoisted_23 = {
  key: 0,
  class: "pFAQ_content_wrapper"
}
const _hoisted_24 = { class: "pFAQ_title" }
const _hoisted_25 = ["data-streamId", "onClick"]
const _hoisted_26 = { class: "pFAQ_title" }
const _hoisted_27 = { class: "pFAQ_content" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "pFAQ_content_actions" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "pFAQ_empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_header_mobile = _resolveComponent("as-header-mobile")!
  const _component_as_preloader = _resolveComponent("as-preloader")!
  const _component_icon_right_arrow = _resolveComponent("icon-right-arrow")!
  const _component_as_banners_catalog = _resolveComponent("as-banners-catalog")!
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_breadcrumb = _resolveComponent("as-breadcrumb")!
  const _component_as_header_main = _resolveComponent("as-header-main")!
  const _component_as_menu = _resolveComponent("as-menu")!
  const _component_as_banner = _resolveComponent("as-banner")!
  const _component_as_banners_top = _resolveComponent("as-banners-top")!
  const _component_as_empty = _resolveComponent("as-empty")!
  const _component_as_row = _resolveComponent("as-row")!
  const _component_as_spacer = _resolveComponent("as-spacer")!
  const _component_as_footer = _resolveComponent("as-footer")!
  const _component_as_tech_question = _resolveComponent("as-tech-question")!
  const _component_as_modal = _resolveComponent("as-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mq_responsive, {
      class: "smFaq",
      target: "mobile-tablet"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_header_mobile, {
          "custom-back": "",
          onGoBack: _ctx.goBack,
          title: _ctx.$t('supportCenter'),
          "onMenu:toggle": _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenMenu = $event))
        }, null, 8, ["onGoBack", "title"]),
        (_ctx.loading)
          ? _withDirectives((_openBlock(), _createBlock(_component_as_preloader, { key: 0 }, null, 512)), [
              [_vShow, !_ctx.isOpenMenu]
            ])
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_ctx.selectedCategory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('selectTopic')), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["pFAQ_categories", {
              '-not-selected': !_ctx.isSelectedCategory
            }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `question-${i}`,
                          class: _normalizeClass(["pFAQ_category", [
                _ctx.isActiveCategory(category.id) ? '-active' : ''
              ]]),
                          "data-categoryId": category.id,
                          onClick: ($event: any) => (_ctx.setContent(category.id))
                        }, [
                          _createTextVNode(_toDisplayString(category.title) + " ", 1),
                          _createVNode(_component_icon_right_arrow, {
                            iconColor: _ctx.IconRightArrowColor('category', category.id)
                          }, null, 8, ["iconColor"])
                        ], 10, _hoisted_5))
                      }), 128))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedCategory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.showSelectionStream)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('selectCourse')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCourseStreams, (userCourseStream, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `stream-${i}`,
                                class: "pFAQ_stream",
                                "data-streamId": userCourseStream.stream.id,
                                onClick: ($event: any) => (_ctx.setStreamId(userCourseStream.stream.id))
                              }, [
                                _createTextVNode(_toDisplayString(userCourseStream.course.title) + " ", 1),
                                _createVNode(_component_icon_right_arrow, { iconColor: "#8898B1" })
                              ], 8, _hoisted_9))
                            }), 128))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.selectedCategory.title), 1),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["pFAQ_content_text", {
                    '-withAutoResolveButton': _ctx.selectedCategory.allowAutoResolve
                  }]),
                                innerHTML: _ctx.selectedCategory.description
                              }, null, 10, _hoisted_12),
                              _createElementVNode("div", _hoisted_13, [
                                (_ctx.selectedCategory.allowAutoResolve)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "pFAQ_content_button",
                                      disabled: _ctx.autoResolveBtnDisabled,
                                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.autoResolveHandler && _ctx.autoResolveHandler(...args)))
                                    }, _toDisplayString(_ctx.selectedCategory.submitButtonText), 9, _hoisted_14))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  class: "pFAQ_tech",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showTech && _ctx.showTech(...args)))
                                }, _toDisplayString(_ctx.$t('writeInSupport')), 1)
                              ])
                            ])
                          ], 64))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, !_ctx.isOpenMenu]
            ]),
        _withDirectives(_createVNode(_component_as_banners_catalog, {
          banners: _ctx.bannersCatalog,
          position: _ctx.bannersPosition
        }, null, 8, ["banners", "position"]), [
          [_vShow, !_ctx.isOpenMenu]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_mq_responsive, {
      class: "lCommon bg-blue",
      target: "desktop"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_header_main, null, {
          breadcrumb: _withCtx(() => [
            _createVNode(_component_as_breadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"])
          ]),
          _: 1
        }),
        _createVNode(_component_as_row, null, {
          menu: _withCtx(() => [
            _createVNode(_component_as_menu, {
              menu: _ctx.menu,
              type: "sidebar"
            }, null, 8, ["menu"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannersSidebar, (banner, i) => {
              return (_openBlock(), _createBlock(_component_as_banner, {
                key: `bannerSidebar${i}`,
                banner: banner,
                platform: _ctx.bannersPlatforms.desktop,
                position: _ctx.bannersPosition,
                placement: _ctx.bannersPlacements.sidebar
              }, null, 8, ["banner", "platform", "position", "placement"]))
            }), 128))
          ]),
          content: _withCtx(() => [
            _createVNode(_component_as_banners_top, {
              banners: _ctx.bannersTop,
              position: _ctx.bannersPosition,
              placement: _ctx.bannersPlacements.top,
              platform: _ctx.bannersPlatforms.desktop
            }, null, 8, ["banners", "position", "placement", "platform"]),
            _createVNode(_component_as_row, { class: "-inner lgFaq" }, {
              content: _withCtx(() => [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_as_preloader, { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.selectedStreamId)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", {
                                class: "pFAQ_go-back",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                              }, "← " + _toDisplayString(_ctx.$t('returnBack')), 1),
                              _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t('selectCourse')), 1),
                              _createElementVNode("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCourseStreams, (userCourseStream, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `stream-${i}`,
                                    class: _normalizeClass(["pFAQ_category", [
                        _ctx.isActiveStream(userCourseStream.stream.id) ? '-active' : ''
                      ]]),
                                    "data-streamId": userCourseStream.stream.id,
                                    onClick: ($event: any) => (_ctx.setStreamId(userCourseStream.stream.id))
                                  }, [
                                    _createTextVNode(_toDisplayString(userCourseStream.course.title) + " ", 1),
                                    _createVNode(_component_icon_right_arrow, {
                                      iconColor: _ctx.IconRightArrowColor('stream', userCourseStream.stream.id)
                                    }, null, 8, ["iconColor"])
                                  ], 10, _hoisted_19))
                                }), 128)),
                                (_ctx.userCourseStreams.length === 0)
                                  ? (_openBlock(), _createBlock(_component_as_empty, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('notFoundCourses')), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("h1", _hoisted_20, _toDisplayString(_ctx.$t('selectTopic')), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["pFAQ_categories", {
                      '-not-selected': !_ctx.isSelectedCategory
                    }])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `question-${i}`,
                                    class: _normalizeClass(["pFAQ_category", [
                        _ctx.isActiveCategory(category.id) ? '-active' : ''
                      ]]),
                                    "data-categoryId": category.id,
                                    onClick: ($event: any) => (_ctx.setContent(category.id))
                                  }, [
                                    _createTextVNode(_toDisplayString(category.title) + " ", 1),
                                    _createVNode(_component_icon_right_arrow, {
                                      iconColor: _ctx.IconRightArrowColor('category', category.id)
                                    }, null, 8, ["iconColor"])
                                  ], 10, _hoisted_21))
                                }), 128))
                              ], 2)
                            ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (_ctx.selectedCategory)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_ctx.showSelectionStream)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.$t('selectCourse')), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCourseStreams, (userCourseStream, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `stream-${i}`,
                                        class: "pFAQ_stream",
                                        "data-streamId": userCourseStream.stream.id,
                                        onClick: ($event: any) => (_ctx.setStreamId(userCourseStream.stream.id))
                                      }, [
                                        _createTextVNode(_toDisplayString(userCourseStream.course.title) + " ", 1),
                                        _createVNode(_component_icon_right_arrow, { iconColor: "#8898B1" })
                                      ], 8, _hoisted_25))
                                    }), 128)),
                                    (_ctx.userCourseStreams.length === 0)
                                      ? (_openBlock(), _createBlock(_component_as_empty, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('notFoundCourses')), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.selectedCategory.title), 1),
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("div", {
                                        class: "pFAQ_content_text",
                                        innerHTML: _ctx.selectedCategory.description
                                      }, null, 8, _hoisted_28),
                                      _createElementVNode("div", _hoisted_29, [
                                        (_ctx.selectedCategory.allowAutoResolve)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "pFAQ_content_button",
                                              disabled: _ctx.autoResolveBtnDisabled,
                                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.autoResolveHandler && _ctx.autoResolveHandler(...args)))
                                            }, _toDisplayString(_ctx.selectedCategory.submitButtonText), 9, _hoisted_30))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                          class: "pFAQ_tech",
                                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showTech && _ctx.showTech(...args)))
                                        }, _toDisplayString(_ctx.$t('writeInSupport')), 1)
                                      ])
                                    ])
                                  ], 64))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t('selectTopicLeft')), 1))
                      ])
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_as_banners_top, {
              banners: _ctx.bannersBottom,
              position: _ctx.bannersPosition,
              placement: _ctx.bannersPlacements.bottom,
              platform: _ctx.bannersPlatforms.desktop
            }, null, 8, ["banners", "position", "placement", "platform"])
          ]),
          _: 1
        }),
        _createVNode(_component_as_spacer),
        _createVNode(_component_as_footer)
      ]),
      _: 1
    }),
    _createVNode(_component_as_modal, {
      modelValue: _ctx.showTechQuestion,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showTechQuestion) = $event)),
      btnClose: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_tech_question, {
          "stream-id": _ctx.selectedStreamId,
          "category-id": _ctx.selectedId,
          class: "pFAQ_techQuestion",
          onSubmit: _ctx.onSubmitTechQuestion
        }, null, 8, ["stream-id", "category-id", "onSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}